import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/Scrolltotop";
import BackToTop from "./components/BackToTop";
import CustomCursor from "./components/CustomCursor";
import "./App.css";

import Home     from "./pages/Home";
import About    from "./pages/About";
import Projects from "./pages/Projects";
import Contact  from "./pages/Contact";

const TicTacToeProject  = lazy(() => import("./projects_pages/Tic-Tac-Toe_project"));
const WednesdayProject  = lazy(() => import("./projects_pages/Wednesday_project"));
const CalculatorProject = lazy(() => import("./projects_pages/calculator"));
const FlipkicksProject  = lazy(() => import("./projects_pages/Flipkicks"));
const GitLensAIProject  = lazy(() => import("./projects_pages/Gitlens_AI"));
const CafeCozyProject   = lazy(() => import("./projects_pages/CafeCozy"));
const TrendiesProject   = lazy(() => import("./projects_pages/Trendies"));
const BSFSchoolProject  = lazy(() => import("./projects_pages/BSFSchool"));
const CodingPassion     = lazy(() => import("./passion_pages/Coding"));
const RoboticsPassion   = lazy(() => import("./passion_pages/Robotics"));
const TattooingPassion  = lazy(() => import("./passion_pages/Tattooing"));
const DrawingPassion    = lazy(() => import("./passion_pages/Drawing"));

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <CustomCursor />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/tic-tac-toe" element={<TicTacToeProject />} />
          <Route path="/projects/flipkicks" element={<FlipkicksProject />} />
          <Route path="/projects/wednesday" element={<WednesdayProject />} />
          <Route path="/projects/calculator" element={<CalculatorProject />} />
          <Route path="/projects/gitlens-ai" element={<GitLensAIProject />} />
          <Route path="/projects/cafe-cozy"      element={<CafeCozyProject />} />
          <Route path="/projects/trendies-smoke" element={<TrendiesProject />} />
          <Route path="/projects/bsf-school"    element={<BSFSchoolProject />} />
          <Route path="/about/coding"    element={<CodingPassion />} />
          <Route path="/about/robotics"  element={<RoboticsPassion />} />
          <Route path="/about/tattooing" element={<TattooingPassion />} />
          <Route path="/about/drawing"   element={<DrawingPassion />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
      <Footer />
      <BackToTop />
    </>
  );
}

export default App;